import { ProtectedRoute } from '../../../router/protectedrouter';

import DashboardPage from "../components/dashboard/OverAllDashboard";
import RequestReportPage from '../components/RequestReportPage';
import MainLayout from '../../../components/layouts/MainLayoutPage';
import PartnerDashboardPage from '../components/PartnerDashboardPage';
import UploadPPTReportPageECS from '../components/UploadPPTReportPageECS';
import UploadFiles from '../components/UploadFiles';
import ReportValidate from '../components/ReportValidate';
import ViewReport from '../components/ViewReport.jsx';
import AlertsPage from '../components/dashboard/AlertsPage.jsx';
import SingleAlertPage from '../components/dashboard/SingleAlertPage.jsx';
import RequestNewScanECS from '../components/RequestNewScan.jsx';
import SummaryReport from '../components/SummaryReport.jsx';
import ViewPDF from '../components/ViewPDF.jsx';
import UserGuidePage from '../components/UserGuide.jsx';
import ConfigureDimensions from '../components/ConfigureDimensions';
import DimensionWeightageConfigure from '../components/DimensionWeightageConfigure';
const base_url="/crs";
const routes = [
    {
        path: `${base_url}`,
        children:[
            {
                path: `request-reports`,
                element: <ProtectedRoute> <MainLayout> <RequestReportPage /> </MainLayout> </ProtectedRoute>,
                name: "requestreports",
            },
            {
                path: `upload-ppt-reports`,
                element: <ProtectedRoute> <MainLayout> <UploadPPTReportPageECS /> </MainLayout> </ProtectedRoute>,
                name: "uploadpptreportsECS",
            },
            {
                path: `configure-dimensions-ecs`,
                element: <ProtectedRoute> <MainLayout> <ConfigureDimensions /> </MainLayout> </ProtectedRoute>,
                name: "configuredimensionsECS",
            },
            {
                path: `dimensions-weightage-ecs`,
                element: <ProtectedRoute> <MainLayout> <DimensionWeightageConfigure /> </MainLayout> </ProtectedRoute>,
                name: "dimensionsweightageECS",
            },
            {
                path: `partner-dashboard`,
                element: <ProtectedRoute><MainLayout> <PartnerDashboardPage /> </MainLayout></ProtectedRoute>,
                name: "partnerdashboard",
            },
            {
                path: `dashboard/:category?`,
                // path: `dashboard/over-all`,
                element: <ProtectedRoute><MainLayout> <DashboardPage /> </MainLayout></ProtectedRoute>,
                name: "dashboard",
            },
            {
                path: `upload-files/:reportId`,
                element: <ProtectedRoute><MainLayout> <UploadFiles/> </MainLayout></ProtectedRoute>,
                name: "uploadfiles",
            },
            {
                path: `report/:id`,
                element: <ProtectedRoute><MainLayout> <ReportValidate/> </MainLayout></ProtectedRoute>,
                name: "reportvalidate",
            },
            {
                path: `category-threats-dashboard/category-threats`,
                element: <ProtectedRoute><MainLayout> <AlertsPage/> </MainLayout></ProtectedRoute>,
                name: "alertspage",
            },
            {
                path: `viewreports`,
                element : <ProtectedRoute><MainLayout> <ViewReport/> </MainLayout></ProtectedRoute>
            },
            {
                path: `threat/:id`,
                element: <ProtectedRoute><MainLayout> <SingleAlertPage/> </MainLayout></ProtectedRoute>,
                name: "singlealertpage",
            },
            {
                path : `requestnewscan`,
                element : <ProtectedRoute> <MainLayout> <RequestNewScanECS/> </MainLayout> </ProtectedRoute>,
                name : "RequestNewScan",
            },
            {
                path: `pdfreport`,
                element: <ProtectedRoute><MainLayout> <SummaryReport/> </MainLayout></ProtectedRoute>,
                name: "summaryreport",
            },
            {
                path: `viewpdf`,
                element: <ProtectedRoute><MainLayout> <ViewPDF/> </MainLayout></ProtectedRoute>,
                name: "viewpdf",
            },
            {
                path: `UserGuidePage`,
                element: <ProtectedRoute><MainLayout> <UserGuidePage/> </MainLayout></ProtectedRoute>,
                name: "viewpdf",

            },

            
            
            
        ]
    },
]


export default routes;